import { h, Component } from 'preact'
import PostAPI from '../api/PostAPI'
import Posts from '../components/Posts'
import Loader from '../components/Loader'
import FilterButton from '../components/FilterButton'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      current_filter: 'company',
      isLoading: true,
      error: false,
    }

    this.handleFilterClick = this.handleFilterClick.bind(this)
  }

  componentDidMount() {
    this.fetchPosts()
  }

  fetchPosts() {
    this.setState({isLoading: true})

    PostAPI.all(this.state.current_filter)
    .then(response => response.json())
    .then(data => {
      window.setTimeout(() => {
        this.setState({
          posts: data,
          isLoading: false,
        })
      }, 500)
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  handleFilterClick(type) {
    this.setState( () => {
      return { 
        current_filter: type
      }
    }, this.fetchPosts )
  }

  render() {
    const appClass = `c-vacancies-app c-vacancies-app--${this.props.color}`

    return (
      <div className={appClass}>

        <div className="c-vacancies-header u-flex u-flex-sb u-flex-v-center">
          <h2 className="c-vacancies-header__title u-1/1@s-o">{this.props.title}</h2>

          {this.props.show_filters !== 'hide' ? (
            <div className="c-vacancies-header__filter u-1/1@s-o">
              <FilterButton 
                type="company" 
                name="Bedrijf" 
                current={this.state.current_filter} 
                loading={this.state.isLoading}
                onClick={this.handleFilterClick} 
              />
              <FilterButton 
                type="location" 
                name="Locatie" 
                current={this.state.current_filter} 
                loading={this.state.isLoading}
                onClick={this.handleFilterClick} 
              />
              <FilterButton 
                type="time" 
                name="Tijd" 
                current={this.state.current_filter} 
                loading={this.state.isLoading}
                onClick={this.handleFilterClick} 
              />
            </div>
          ) : null }
        </div>

        { this.state.isLoading ? (
          <Loader />
        ) : (
               
          Object.keys(this.state.posts).map((key) => {
            return (
              <Posts
                posts={this.state.posts[key]}
                loading={this.state.isLoading}
                error={this.state.error}
                title={key}
              /> 
            )
          })

        ) }

      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/vacancies/containers/App.js